import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {SHARE_OF_BROWSE_ROUTES, HOME_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import {startDate, endDate, resetCommonFilters} from "@signals"
import {useShareOfSearch} from "./@hooks";
import ShareOfSearchTable from "./Table";


export default function ShareOfSearchPage() {
    const { callShareOfSearchData } = useShareOfSearch()

    const props = {
        head: `DIP Insight | ${SHARE_OF_BROWSE_ROUTES.SHARE_TITLE}`,
        title: SHARE_OF_BROWSE_ROUTES.SHARE_TITLE,
        subtitle: SHARE_OF_BROWSE_ROUTES.SHARE_SUBTITLE,
        isEmpty: false,
    }

    useEffect(() => {
        resetCommonFilters()
    }, [])

    useEffect(() => {
        callShareOfSearchData()
    }, [startDate.value, endDate.value]);

    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12}>

            </Grid>

            <Grid item xs={12}>
                <ShareOfSearchTable />
            </Grid>
        </Grid>
    </PageWrapper>
}